// Strict check for the Shopify plan-selection URL the backend returns (shopify_entitlement.plan_url shape:
// https://admin.shopify.com/store/<shop-handle>/charges/<app-handle>/pricing_plans). Replaces a prefix-only
// startsWith() trust check. Previous check kept in ShopifyEmbeddedApp.js as a comment.
const PATH = /^\/store\/[a-z0-9][a-z0-9-]*\/charges\/[a-z0-9][a-z0-9_-]*\/pricing_plans$/;

export function isShopifyPlanUrl(value) {
  if (typeof value !== 'string') return false;
  let u;
  try { u = new URL(value); } catch (e) { return false; }
  return u.protocol === 'https:' && u.hostname === 'admin.shopify.com' && u.port === '' &&
    u.username === '' && u.password === '' && u.search === '' && u.hash === '' && PATH.test(u.pathname);
}
